import { gql } from '@apollo/client';

import APPOINTMENT_ASSIGNMENTS from '../fragments/appointmentAssignments/appointmentAssignments';

export const CREATE_APPOINTMENT_ASSIGNMENT = gql`
  ${APPOINTMENT_ASSIGNMENTS}
  mutation createAssignmentEntity($doc: AssignmentInput!) {
    createAssignmentEntity(doc: $doc) {
      ...AppointmentAssignments
    }
  }
`;

export const UPDATE_APPOINTMENT_ASSIGNMENT = gql`
  ${APPOINTMENT_ASSIGNMENTS}
  mutation updateAssignmentEntity($updatedDoc: AssignmentInput!, $filter: AssignmentInput!) {
    updateAssignmentEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...AppointmentAssignments
    }
  }
`;

export const DELETE_APPOINTMENT_ASSIGNMENT = gql`
  mutation deleteAssignmentEntity($id: String!) {
    deleteAssignmentEntity(id: $id) {
      message
    }
  }
`;

export const CREATE_MANY_APPOINTMENT_ASSIGNMENT = gql`
  ${APPOINTMENT_ASSIGNMENTS}
  mutation createManyAssignmentEntity($doc: [AssignmentInput!]!) {
    createManyAssignmentEntity(doc: $doc) {
      ...AppointmentAssignments
    }
  }
`;

export const UPDATE_MANY_APPOINTMENT_ASSIGNMENT = gql`
  ${APPOINTMENT_ASSIGNMENTS}
  mutation updateManyAssignmentEntity($updatedDoc: [AssignmentInput!]!, $filter: [AssignmentInput!]!) {
    updateManyAssignmentEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...AppointmentAssignments
    }
  }
`;

export const DELETE_MANY_APPOINTMENT_ASSIGNMENT = gql`
  mutation deleteManyAssignmentEntity($id: [String!]!) {
    deleteManyAssignmentEntity(id: $id) {
      message
    }
  }
`;
